/* Weebot — cœur de recherche partagé (dropdown + page /search). UNE seule source pour
   synonymes, détection d'intention pièce, chargement de l'index et classement.
   Charge Fuse.js avant ce script. Usage : WBSearch.setIndex(url); WBSearch.search(q, cb). */
window.WBSearch = (function () {
  // Synonymes / fautes (marques + catégories). Fuse gère le flou général ; ici les cas à forcer.
  var SYN = {
    'dualton':'dualtron','daultron':'dualtron','doualtron':'dualtron','dualtrons':'dualtron',
    'kabo':'kaabo','kaboo':'kaabo','cabo':'kaabo','kaaboo':'kaabo',
    'segwai':'segway','segwait':'segway','sigway':'segway',
    'ninbot':'ninebot','ninebott':'ninebot','nimebot':'ninebot',
    'xiomi':'xiaomi','ziaomi':'xiaomi','shaomi':'xiaomi','xaomi':'xiaomi',
    'teverune':'teverun','teverrun':'teverun','langfaite':'langfeite','langfeit':'langfeite',
    'rovorone':'rovoron','rovorron':'rovoron','etwow':'e-twow','etwo':'e-twow','ettwow':'e-twow','inoe':'inöe',
    'trotinette':'trottinette','trotinete':'trottinette','trotinnette':'trottinette','trottinete':'trottinette',
    'velos':'vélo','velo':'vélo','vélos':'vélo','vae':'vélo électrique',
    'electrique':'électrique','electric':'électrique','casqu':'casque','pneux':'pneu','pneus':'pneu'
  };
  // Mots indiquant que l'utilisateur cherche une PIÈCE/ACCESSOIRE -> on ne force pas les produits en tête.
  var PART_INTENT = ['moteur','béquille','bequille','casque','plaquette','plaquettes','pneu','chambre','chargeur',
    'batterie','roue','disque','frein','freins','écran','ecran','guidon','poignée','poignee','gâchette','gachette',
    'phare','clignotant','jante','contrôleur','controleur','commodo','support','cache','bague','kit','housse',
    'sacoche','antivol','gant','gants','garde','garde-boue','folding','potence','fourche','étrier','etrier','axe',
    'roulement','capteur','feu','sonnette','rétroviseur','retroviseur','durite','câble','cable','levier','amortisseur',
    'suspension','grip','valve','moyeu','adaptateur','connecteur','display','accessoire','accessoires','pièce','piece',
    'pièces','pieces','protège','protege','protection','vis','écrou','ecrou','tube','axe'];

  var STOP = ['pour','de','des','du','le','la','les','et','ou','un','une','en','à','a','avec','sur'];
  var fuse = null, items = null, indexUrl = null, loading = false, waiters = [];
  function expand(q) { return q.toLowerCase().split(/\s+/).map(function (w) { return SYN[w] || w; }).join(' '); }
  function isPartQuery(q) {
    var ws = q.toLowerCase().split(/\s+/);
    for (var i = 0; i < ws.length; i++) { if (PART_INTENT.indexOf(ws[i]) >= 0) return true; }
    return false;
  }
  function ensure(cb) {
    if (fuse) { cb(); return; }
    waiters.push(cb);
    if (loading) return;
    loading = true;
    (function load() {
      if (typeof Fuse === 'undefined') { setTimeout(load, 100); return; }
      fetch(indexUrl).then(function (r) { return r.json(); }).then(function (d) {
        fuse = new Fuse(d.products, { keys: [{ name: 't', weight: .62 }, { name: 'b', weight: .26 }, { name: 'ty', weight: .12 }], threshold: .34, ignoreLocation: true, minMatchCharLength: 2, includeScore: true });
        items = d.products;
        var w = waiters; waiters = []; w.forEach(function (f) { f(); });
      }).catch(function () { loading = false; });
    })();
  }
  // Scoring PAR MOT : on cherche chaque mot séparément (fuzzy) ; un produit est d'autant mieux classé
  // qu'il contient PLUS de mots de la requête. Le mot-pièce (moteur, casque…) compte double -> il pilote.
  function search(q, cb) {
    var eq = expand(q);
    var toks = eq.split(/\s+/).filter(function (w) { return w.length >= 2 && STOP.indexOf(w) < 0; });
    ensure(function () {
      // Recherche par SKU (champ "s" de l'index : SKUs normalisés MAJ/alphanum, séparés par espace).
      // Exact = toujours ; préfixe/fragment = seulement si la saisie contient un chiffre
      // (évite qu'un mot courant remonte un produit par collision avec un SKU en lettres).
      var skuTop = [];
      var qn = q.toUpperCase().replace(/[^A-Z0-9]/g, '');
      if (items && qn.length >= 4) {
        var withDigit = /\d/.test(qn);
        for (var i = 0; i < items.length; i++) {
          var s = items[i].s; if (!s) continue;
          var parts = s.split(' ');
          for (var k = 0; k < parts.length; k++) {
            var pk = parts[k];
            if (pk === qn) { skuTop.push({ item: items[i], pr: 0 }); break; }
            if (withDigit && qn.length >= 5 && pk.indexOf(qn) === 0) { skuTop.push({ item: items[i], pr: 1 }); break; }
            if (withDigit && qn.length >= 6 && pk.indexOf(qn) > 0) { skuTop.push({ item: items[i], pr: 2 }); break; }
          }
        }
        skuTop.sort(function (a, b) { return a.pr - b.pr; });
      }
      if (!fuse || !toks.length) { cb(skuTop.map(function (x) { return x.item; }), eq); return; }
      var partQ = false, acc = {};
      toks.forEach(function (tok) {
        var isPart = PART_INTENT.indexOf(tok) >= 0; if (isPart) partQ = true;
        var wgt = isPart ? 2 : 1;
        fuse.search(tok).forEach(function (r) {
          var h = r.item.h, e = acc[h] || (acc[h] = { item: r.item, w: 0, score: r.score });
          e.w += wgt; if (r.score < e.score) e.score = r.score;
        });
      });
      var arr = []; for (var h in acc) arr.push(acc[h]);
      arr.sort(function (a, b) {
        if (a.w !== b.w) return b.w - a.w;                              // + de mots de la requête matchés (pièce = x2)
        if (!partQ) { var r = a.item.r - b.item.r; if (r) return r; }   // requête marque/modèle -> produits avant pièces
        var s = (b.item.a || 0) - (a.item.a || 0); if (s) return s;     // en stock (précommande incluse) d'abord
        return a.score - b.score;                                        // puis pertinence Fuse
      });
      // Les matchs SKU passent DEVANT les résultats fuzzy (dédupliqués par handle)
      var seen = {}, out = [];
      skuTop.forEach(function (x) { if (!seen[x.item.h]) { seen[x.item.h] = 1; out.push(x.item); } });
      arr.forEach(function (x) { if (!seen[x.item.h]) { seen[x.item.h] = 1; out.push(x.item); } });
      cb(out, eq);
    });
  }
  return { setIndex: function (u) { indexUrl = u; }, expand: expand, isPartQuery: isPartQuery, search: search };
})();
